import Marquee from "react-fast-marquee";

export default function AutoScrollLine() {
  return (
    <Marquee
      gradient={false}
      speed={30} // slightly slower for elegance
      pauseOnHover
      className="py-1 bg-dark text-light border-top border-bottom"
      style={{
        fontSize: ".8rem",
        letterSpacing: "1px",
        textTransform: "uppercase",
        opacity: 0.9, // subtle transparency
      }}
    >
      <span style={{ margin: "0 3.2rem" }}>Bulk Orders Only</span>
      <span style={{ margin: "0 3.2rem" }}>Exclusive B2B Collection</span>
      <span style={{ margin: "0 3.2rem" }}>Bulk Orders Only</span>
      <span style={{ margin: "0 3.2rem" }}>Exclusive B2B Collection</span>
      <span style={{ margin: "0 3.2rem" }}>Bulk Orders Only</span>
      <span style={{ margin: "0 3.2rem" }}>Exclusive B2B Collection</span>
    </Marquee>
  );
}
